<template>
	<div class="">
		<header>
			<div class="container">
				<div class="header-content">
					<div class="left-side">
						<div
							class="logo-wrap"
							@click="returnToHomeView"
						>
							<router-link to="/">
								<img class="logo-img" src="../assets/images/logo.svg" alt="">
							</router-link>
						</div>
					</div>
					<div class="right-side">
						<div class="menu-wrap">
							<router-link to="/" v-if="$route.name == 'Chat'" class="menu-item me-3">
								Secret Message
							</router-link>
							<a v-else href="#" @click.prevent="$bvModal.show('modal-show-chat')" class="menu-item me-3">Secret
								Chat</a>
							<a href="/blog" class="menu-item me-3">Blog</a>
							<a href="/blog/page/about/" class="menu-item">About</a>
						</div>
						<div class="d-flex align-items-center" v-if="!logged_in">
							<a @click.prevent="$bvModal.show('modal-login'), afterLoginMsg = false"
							   class="header-login">Login</a>
							<a @click.prevent="$bvModal.show('modal-sign-up')" class="btn-header ms-3">Sign Up</a>
						</div>
						<button @click.prevent="openDashboard()" class="btn-header" v-if="logged_in">Dashboard</button>
					</div>
				</div>
			</div>
		</header>
		<b-modal id="modal-sign-up"
				 hide-footer
				 hide-header
				 @shown="$refs.sign_up_input_email.focus()"
		>
			<div class="wrap-img">
				<img src="../assets/images/ducks/send.png" alt="">
			</div>
			<div v-if="afterLoginMsg" class="modal-content">
				<h2 class="title-modal">
					Sign Up
				</h2>
				<div class="premiun-text mb-0">
					<p class="mb-3">
						Thank you for signing up! Enjoy the Duckist password sharing experience!
					</p>
					<p class="mb-0">
						We have sent a magic link to your email inbox. Please use the provided link to login
					</p>
				</div>
			</div>
			<div v-else class="modal-content">
				<h2 class="title-modal">
					Sign Up
				</h2>
				<div class="premiun-text">
					<p class="mb-0" style="max-width: 300px; margin: 0 auto;">
						Already have an account? <a class="open-modal" @click.prevent="$bvModal.show('modal-login'), $bvModal.hide('modal-sign-up')" href="#">Click Here</a>.
					</p>
				</div>
				<form>
					<div class="form-group wrap-input-modal">
						<input ref="sign_up_input_email" v-model="email" required type="email" class="form-control input-modal"
							   placeholder="Your Email">
					</div>
					<div class="">
						<input @click.prevent="signUp()" :disabled="!email" type="submit" class="submit-modal"
							   value="Register">
					</div>
				</form>
			</div>
		</b-modal>
		<b-modal id="modal-login"
				 hide-footer
				 hide-header
				 @shown="$refs.login_input_email.focus()"
		>
			<div class="wrap-img">
				<img src="../assets/images/ducks/send.png" alt="">
			</div>
			<div class="modal-content">
				<h2 class="title-modal">
					Login
				</h2>
				<p style="max-width: 300px; margin: 0 auto 35px auto;">
					Don't have an account? <a class="open-modal" @click.prevent="$bvModal.hide('modal-login'), $bvModal.show('modal-sign-up')" href="#">Click Here</a>.
				</p>
				<div v-if="afterLoginMsg">
					<p class="text-center mb-0">
						We have sent a magic link to your email inbox. Please use the provided link to login
					</p>
				</div>
				<form v-else>
					<div class="form-group wrap-input-modal">
						<input ref="login_input_email" v-model="email" required type="email" class="form-control input-modal"
							   placeholder="Your Email">
					</div>
					<div class="">
						<input @click.prevent="login()" :disabled="!email" type="submit" class="submit-modal"
							   value="Login">
					</div>
				</form>
			</div>
		</b-modal>
		<Flash ref="show"/>
	</div>
</template>

<script>
	import axios from "axios";
	import Flash from "../components/Flash";
	import {eventBus} from '../main'
	import {api} from "../mixins/axios";

	export default {
		name: 'Header',
		components: {
			Flash,
		},
		data() {
			return {
				logged_in: false,
				afterLoginMsg: false,
				email: '',
				showSideMenu: false,
				host: "",
			}
		},
		methods: {
			returnToHomeView() {
				eventBus.$emit('update-active-view', 'home');
				this.showSideMenu = false;
				eventBus.$emit('openDashboard', this.showSideMenu);
			},
			async signUp() {
				if (!this.validateEmail()) {
					this.$refs.show.showFlashError("Not A Valid Email")
					return
				}
				localStorage.clear();
				let requestOptions = {
					email: this.email,
					...(location.hostname !== "localhost" && {info: getLog()}),
				};
				await api.put(`/users/new`, requestOptions)
					.then(response => {
						if (response.data.status == 'ok') {
							this.$refs.show.showFlashSuccess('Thank you for signing up!');
							localStorage.setItem('logged_in', this.logged_in);
							localStorage.setItem('email', this.email);
							this.afterLoginMsg = true;
							setTimeout(() => {
								this.$bvModal.hide('modal-sign-up')
							},3000)
						}
					}).catch(e => {
						console.log(e.response.data);
						setTimeout(() => {
							this.$bvModal.hide('modal-sign-up')
						},3000)
						if (e.response.data.status == 'error') {
							this.login()
						} else this.$refs.show.showFlashError(e.response.data.msg)

					})
			},
			async login() {
				if (!this.validateEmail()) {
					this.$refs.show.showFlashError("Not A Valid Email")
					return
				}
				localStorage.clear();
				let requestOptions = {
					email: this.email,
					...(location.hostname !== "localhost" && {info: getLog()}),
				};
				await api.put(
					`/users/login`,
					requestOptions
				).then(response => {
					if (response.data.status == 'ok') {
						this.afterLoginMsg = true;
						localStorage.setItem('email', this.email);
						setTimeout(() => {
							this.$bvModal.hide('modal-login')
						}, 2000)
					}
				}).catch(e => {
					console.log(e.response.data.msg);
					this.$refs.show.showFlashError(e.response.data.msg)
				})
			},
			validateEmail() {
				let validEmail = this.email
					.toLowerCase()
					.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
				if (validEmail) {
					return true
				} else {
					return false
				}
			},
			openDashboard() {
				this.showSideMenu = !this.showSideMenu
				eventBus.$emit('openDashboard', this.showSideMenu);
			},
			openSideMenu(data) {
				this.showSideMenu = data
			},
			closeSideMenu() {
				this.showSideMenu = false
			}
		},
		mounted() {
			if (localStorage.accessToken) {
				this.logged_in = true
			}
			this.host = location.origin

			eventBus.$on('openSideMenu', this.openSideMenu);
			eventBus.$on('closeSideMenu', this.openSideMenu);
			eventBus.$on('logOut', () => {
				this.logged_in = false
			});
		},
		destroyed() {
			eventBus.off('openSideMenu', this.closeSideMenu);
			eventBus.off('closeSideMenu', this.closeSideMenu);
			eventBus.off('logOut');
		}
	}
</script>

<style scoped lang="scss">
	@import "../assets/scss/header.scss";

	::v-deep .modal-body {
		padding: 0;
	}

	.modal-content {
		padding: 20px 25px 25px 25px;
		@include media-breakpoint-up(sm) {
			padding: 40px 50px 50px 50px;
		}
	}

	.wrap-img {
		padding-top: 26px;
		padding-bottom: 26px;
		background: #21405B;
		text-align: center;
		min-height: 169px;
	}

	.title-modal {
		font-weight: bold;
		font-size: 30px;
		line-height: 37px;
		letter-spacing: -0.02em;
		color: #323232;
		margin-bottom: 20px;
		text-align: center;
	}

	.premiun-text {
		font-size: 16px;
		line-height: 28px;
		text-align: center;
		letter-spacing: -0.02em;
		color: #6C6C74;
		margin-bottom: 35px;
	}

	.input-modal {
		margin-bottom: 20px;
		font-size: 16px;
		line-height: 28px;
		letter-spacing: -0.02em;
		color: #6C6C74;
		background: #F6F6F6;
		border-radius: 2px;
		border: none;
		padding: 13px 15px;
		outline: none;
		box-shadow: unset;
	}

	.submit-modal {
		background: #FF7A00;
		border-radius: 6px;
		font-weight: 600;
		font-size: 16px;
		line-height: 28px;
		text-align: center;
		letter-spacing: -0.02em;
		color: #FFFFFF;
		width: 100%;
		padding: 13px 15px;
		outline: none;
		box-shadow: unset;
		border: none;

		&:hover {
			background: #21405B;
		}

		&:disabled {
			background: #ff962e;
		}
	}

	.open-modal{
		color: #FF7A00;
		text-decoration: none;
		font-weight: 600;
	}
</style>
